function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import 'babel-polyfill';
import 'picturefill';

//Browser detection. There may be a better place for this?
if (window.navigator) {
  //Nasty mac detection for. No choice. Sorry :-(
  document.body.classList.add(window.navigator.platform.indexOf('Mac') > -1 ? 'is-mac' : 'is-non-mac');
}
import * as ReactHabitat from 'react-habitat';
import { createStore } from 'redux';
import ReduxFactory from './ReduxFactory';

// Reducers
import rootReducer from './reducers/Index';

// Define redux devtools prop on global window object

// Define our site config which is set in the .NET page template
// Doing this prevents linting errors for undefined variables
var App = /*#__PURE__*/function (_ReactHabitat$Bootstr) {
  function App() {
    var _this;
    _classCallCheck(this, App);
    _this = _callSuper(this, App);

    // Create a habitat container builder
    var containerBuilder = new ReactHabitat.ContainerBuilder();

    // Create redux store and pass through the root reducer
    var store = createStore(rootReducer, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());

    // Set the container to use our redux factory
    containerBuilder.factory = new ReduxFactory(store);

    // Set the dynamic importing
    containerBuilder.registerAsync(function () {
      return import('./components/AthleteCarousel');
    }).as('AthleteCarousel');
    containerBuilder.registerAsync(function () {
      return import('./components/AthleteCard');
    }).as('AthleteCard');
    containerBuilder.registerAsync(function () {
      return import('./components/AthleteList');
    }).as('AthleteList');
    containerBuilder.registerAsync(function () {
      return import('./components/ArticleImage');
    }).as('ArticleImage');
    containerBuilder.registerAsync(function () {
      return import('./components/CookieBanner');
    }).as('CookieBanner');
    containerBuilder.registerAsync(function () {
      return import('./components/ContentBlock');
    }).as('ContentBlock');
    containerBuilder.registerAsync(function () {
      return import('./components/FeaturedAthletes');
    }).as('FeaturedAthletes');
    containerBuilder.registerAsync(function () {
      return import('./components/FeaturedVideo');
    }).as('FeaturedVideo');
    containerBuilder.registerAsync(function () {
      return import('./components/Games');
    }).as('Games');
    containerBuilder.registerAsync(function () {
      return import('./components/GameHeroBanner');
    }).as('GameHeroBanner');
    containerBuilder.registerAsync(function () {
      return import('./components/common/Heading');
    }).as('Heading');
    containerBuilder.registerAsync(function () {
      return import('./components/HomeLayout');
    }).as('HomeLayout');
    containerBuilder.registerAsync(function () {
      return import('./components/GamesTimeLayout');
    }).as('GamesTimeLayout');
    containerBuilder.registerAsync(function () {
      return import('./components/ImageLink');
    }).as('ImageLink');
    containerBuilder.registerAsync(function () {
      return import('./components/InlineGallery');
    }).as('InlineGallery');
    containerBuilder.registerAsync(function () {
      return import('./components/ImageBlock');
    }).as('ImageBlock');
    containerBuilder.registerAsync(function () {
      return import('./components/MedalBreakdown');
    }).as('MedalBreakdown');
    containerBuilder.registerAsync(function () {
      return import('./components/NewsList');
    }).as('NewsList');
    containerBuilder.registerAsync(function () {
      return import('./components/NewsListItem');
    }).as('NewsListItem');
    containerBuilder.registerAsync(function () {
      return import('./components/NewsLetterSignUp');
    }).as('NewsLetterSignUp');
    containerBuilder.registerAsync(function () {
      return import('./components/Promo');
    }).as('Promo');
    containerBuilder.registerAsync(function () {
      return import('./components/PersonList');
    }).as('PersonList');
    containerBuilder.registerAsync(function () {
      return import('./components/ProfileHeroBanner');
    }).as('ProfileHeroBanner');
    containerBuilder.registerAsync(function () {
      return import('./components/common/Quote');
    }).as('Quote');
    containerBuilder.registerAsync(function () {
      return import('./components/common/RichText');
    }).as('RichText');
    containerBuilder.registerAsync(function () {
      return import('./components/RelatedContent');
    }).as('RelatedContent');
    containerBuilder.registerAsync(function () {
      return import('./components/SiteSearch');
    }).as('SiteSearch');
    containerBuilder.registerAsync(function () {
      return import('./components/SiteSearchToggle');
    }).as('SiteSearchToggle');
    containerBuilder.registerAsync(function () {
      return import('./components/SharePane');
    }).as('SharePane');
    containerBuilder.registerAsync(function () {
      return import('./components/SportsListings');
    }).as('SportsListings');
    containerBuilder.registerAsync(function () {
      return import('./components/ShopPromo');
    }).as('ShopPromo');
    containerBuilder.registerAsync(function () {
      return import('./components/SponsorList');
    }).as('SponsorList');
    containerBuilder.registerAsync(function () {
      return import('./components/TabbedList');
    }).as('TabbedList');
    containerBuilder.registerAsync(function () {
      return import('./components/VideoObject');
    }).as('VideoObject');
    containerBuilder.registerAsync(function () {
      return import('./components/VideoPlaylist');
    }).as('VideoPlaylist');
    containerBuilder.registerAsync(function () {
      return import('./components/VideoPlaylistAggregator');
    }).as('VideoPlaylistAggregator');
    containerBuilder.registerAsync(function () {
      return import('./components/VideoPlaylistListing');
    }).as('VideoPlaylistListing');
    containerBuilder.registerAsync(function () {
      return import('./components/MedalStandings');
    }).as('MedalStandings');
    containerBuilder.registerAsync(function () {
      return import('./components/CompetitionModule');
    }).as('CompetitionModule');
    containerBuilder.registerAsync(function () {
      return import('./components/ArticleHeader');
    }).as('ArticleHeader');
    containerBuilder.registerAsync(function () {
      return import('./components/SocialLink');
    }).as('SocialLink');
    containerBuilder.registerAsync(function () {
      return import('./components/PromoBanner');
    }).as('PromoBannerModule');
    containerBuilder.registerAsync(function () {
      return import('./components/GamesTimeEventCentre');
    }).as('GamesTimeEventCentre');
    containerBuilder.registerAsync(function () {
      return import('./components/CountdownCard');
    }).as('CountdownCard');
    containerBuilder.registerAsync(function () {
      return import('./components/GatewayCarousel');
    }).as('GatewayCarousel');
    containerBuilder.registerAsync(function () {
      return import('./components/RotatingHeroModule');
    }).as('RotatingHeroModule');
    containerBuilder.registerAsync(function () {
      return import('./components/ButtonModule');
    }).as('Button');
    containerBuilder.registerAsync(function () {
      return import('./components/BannerModule');
    }).as('BannerModule');
    containerBuilder.registerAsync(function () {
      return import('./components/PromoModule');
    }).as('PromoModule');
    containerBuilder.registerAsync(function () {
      return import('./components/GridModule');
    }).as('GridModule');
    containerBuilder.registerAsync(function () {
      return import('./components/AppleAppPrompt');
    }).as('AppleAppPrompt');
    containerBuilder.registerAsync(function () {
      return import('./components/AndroidAppPrompt');
    }).as('AndroidAppPrompt');
    containerBuilder.registerAsync(function () {
      return import('./components/Popup');
    }).as('Popup');

    // Set the DOM container
    _this.setContainer(containerBuilder.build());
    return _this;
  }
  _inherits(App, _ReactHabitat$Bootstr);
  return _createClass(App);
}(ReactHabitat.Bootstrapper); // Create a instanse of a react habitat app
var appInstance = new App();

// this will allow habitat to scan the dom for references to components
window.updateHabitat = appInstance.update.bind(appInstance);
export default appInstance;